// extracted by mini-css-extract-plugin
export default {"smartLink":"smart-link_smartLink__oxMO8"};